export const formatCurrency = (amount: number, currency: string = 'USD'): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  // Handle CDF (Congolese Franc) which might not be supported in all browsers
  if (currency === 'CDF') {
    return `${amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })} CDF`
  }

  return formatter.format(amount)
}

export const formatCurrencyCompact = (amount: number, currency: string = 'USD'): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    notation: 'compact',
    compactDisplay: 'short',
  })

  if (currency === 'CDF') {
    const compact = (amount: number): string => {
      if (amount >= 1e9) return `${(amount / 1e9).toFixed(1)}B CDF`
      if (amount >= 1e6) return `${(amount / 1e6).toFixed(1)}M CDF`
      if (amount >= 1e3) return `${(amount / 1e3).toFixed(1)}K CDF`
      return `${amount} CDF`
    }
    return compact(amount)
  }

  return formatter.format(amount)
}

export const parseCurrency = (value: string): number => {
  // Remove currency symbols and spaces, then parse
  const cleaned = value.replace(/[^\d.-]/g, '')
  const parsed = parseFloat(cleaned)
  return isNaN(parsed) ? 0 : parsed
}